import React from 'react'
import { Checkbox, Col, Row } from 'antd'

import paintingSmall from '../../asset/image/Painting-small.jpeg'
import collageSmall from '../../asset/image/Collage-small.jpeg'
import drawingSmall from '../../asset/image/Drawing-small.jpeg'
import installationDigitalSmall from '../../asset/image/Installation_Digital-small.jpeg'
import mixedMediaSmall from '../../asset/image/Mixed_Media-small.jpeg'
import sculptureSmall from '../../asset/image/Sculpture-small.jpeg'
import '../../asset/less/component.css'

class MediumCheckbox extends React.Component {
  render() {
    const { onChange, value } = this.props
    return (
      <Checkbox.Group onChange={onChange} value={value}>
        <Row justify='space-between' gutter={{xs: 8, sm: 16, md: 24}} style={{width: '100%'}}>
          <Col className='medium-picture'>
            <img src={paintingSmall} alt='Painting' />
            <Checkbox value='painting'>Painting</Checkbox>
          </Col>
          <Col className='medium-picture'>
            <img src={drawingSmall} alt='Drawing' />
            <Checkbox value='drawing'>Drawing</Checkbox>
          </Col>
          <Col className='medium-picture'>
            <img src={sculptureSmall} alt='Sculpture' />
            <Checkbox value='sculpture'>Sculpture</Checkbox>
          </Col>
          <Col className='medium-picture'>
            <img src={collageSmall} alt='Collage' />
            <Checkbox value='collage'>Collage</Checkbox>
          </Col>
          <Col className='medium-picture'>
            <img src={installationDigitalSmall} alt='Installation & Digital' />
            <Checkbox value='installation-digital'>Installation & Digital</Checkbox>
          </Col>
          <Col className='medium-picture'>
            <img src={mixedMediaSmall} alt='Mixed Media' />
            <Checkbox value='mixed-media'>Mixed Media</Checkbox>
          </Col>
        </Row>
      </Checkbox.Group>
    )
  }
}

export default MediumCheckbox
